// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";

export default {
  /**
   * Gets users from backend server
   * @param {boolean} withLicense - to get only users with a license
   * @returns {Promise<Array<object>>} List of UserPreview
   */
  getUsers(withLicense = false) {
    return backend.get("/users?withLicense=" + withLicense);
  },
  /**
   * Ensures user exists in backend database
   * @returns {object} BackendResult
   */
  ensureUser(): Promise<any> {
    return backend.post("/users/ensure", null);
  },
};
